class AnswerKeyWord {
    constructor() {
        this.answerKeyWordId = 0
        this.answerIndex = 0;
        this.isSensitive = false
        this.answers = []
        this.solvedAnswer = ""

    }

    getAsJson = () => {
        let obj = {}
        obj.answerKeyWordId = this.answerKeyWordId
        obj.answerIndex = this.answerIndex
        obj.isSensitive = this.isSensitive
        obj.answers = this.answers
        obj.solvedAnswer = this.solvedAnswer
        return obj
    }


    initFromJson = (obj) => {
        this.answerKeyWordId = obj.answerKeyWordId
        this.answerIndex = obj.answerIndex
        this.isSensitive = obj.isSensitive
        this.answers = obj.answers
        this.solvedAnswer = obj.solvedAnswer
    }

}
export default AnswerKeyWord